import { render, staticRenderFns } from "./EmailPreferenceCentreView.vue?vue&type=template&id=5ebe456e&scoped=true"
import script from "./EmailPreferenceCentreView.vue?vue&type=script&lang=js"
export * from "./EmailPreferenceCentreView.vue?vue&type=script&lang=js"
import style0 from "./EmailPreferenceCentreView.vue?vue&type=style&index=0&id=5ebe456e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe456e",
  null
  
)

export default component.exports